var EntitiesBase = require('./base');
var Obscura = require('backbone.obscura');
var validationUtils = require('./validation');

var ordersCommonMixin = {
  cancel_order: function (model) {
    var self = this;
    var $deferred = $.Deferred();
    var errors = [];
    Backbone.Radio.channel('global')
        .request('ajax', 'farmacyajaxv2-ordercancel', {
            order_id: model.get('order_id'),
            order_unique_id: model.get('order_unique_id'),
            order_customer_id: model.get('order_customer_id')
        })
        .success(function(response) {
            $deferred.resolve(response);
        })
        .fail(function(error) {
            $deferred.reject(error);
        });
    return $deferred.promise();
  },
  get_ready_count: function () {
    var orders_ready = new Obscura(
        this
    );
    orders_ready.filterBy('userLocation', function(model) {
      if (model.get('order_status') == 'ready') {
        return true;
      } else {
        return false;
      }
    });
    return orders_ready.length;
  },
  update_status: function (order_id, order_status, order_payment_status) {
    var model = this.findWhere({'order_id': order_id});
    model.set('order_status', order_status);

    if (order_payment_status) {
      model.set('order_payment_status', order_payment_status);
    }

    return model;
  },
  check_exists: function (order_id)  {
    var model = this.findWhere({'order_id': order_id});
    if (model) {
      return true;
    } else {
      return false;
    }
  },
  remove_by_order_id: function (order_id)  {
    var model = this.findWhere({'order_id': order_id});
    this.remove(model);
  },
  get_active_order_channels: function () {
    var channels = [];
    var active_orders = new Obscura(
        this
    );
    active_orders.filterBy('userLocation', function(model) {
      if (model.get('order_status') == 'pre_payment' ||
      model.get('order_status') == 'created' ||
      model.get('order_status') == 'processing' ||
      model.get('order_status') == 'ready') {
        return true;
      } else {
        return false;
      }
    });
    active_orders.each(function (model) {
      channels.push('orders.' + model.get('order_unique_id'));
    });
    return channels;
  }
};

var OrderModel = EntitiesBase.ModelBase.extend({});

var OrdersCollection = EntitiesBase.CollectionBase.extend({
  model: OrderModel
});

_.extend(OrdersCollection.prototype, ordersCommonMixin);


var FavouriteProductsModel = EntitiesBase.ModelBase.extend({});

var FavouriteProductsCollection = EntitiesBase.CollectionBase.extend({
  model: FavouriteProductsModel
});

var CustomerModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    defaults: {
      first_name: null,
      last_name: null,
      display_name: null,
      email: null,
      phone: null,
      user_id: null,
      favourite_products: new FavouriteProductsCollection(),

    },
    nestedEntities: {
        orders: OrdersCollection,
        favourite_products: FavouriteProductsCollection
    },
    idAttribute: 'user_id'
});

var customerJoinClubValidationMixin = {
    phone: {
        required: true,
        fn: function(value, attr, computedState) {
          if (value == '') {
            return validationUtils.getIsRequiredMessageForFieldName('Phone');
          } else if (value.length < 14) { // 14 seems odd but it's including the space, ( and - in the mask input...
            return 'Must be a valid phone number';
          }
        }
    },
    first_name: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('first_name')
    },
    last_name: {
        required: true,
        msg: validationUtils.getIsRequiredMessageForFieldName('last_name')
    }
  };

var CustomerJoinClubModel = CustomerModel.extend({
    validation: {},
    unsavedChangesIgnoredAttributes: ['orders'],
    methodToActionMap: {
        create: 'farmacyajaxv2-createorupdateclubinfo',
        update: 'farmacyajaxv2-createorupdateclubinfo',
        patch: 'farmacyajaxv2-createorupdateclubinfo'
    }
});
_.extend(CustomerJoinClubModel.prototype, Backbone.Validation.mixin);
_.extend(
    CustomerJoinClubModel.prototype.validation,
    customerJoinClubValidationMixin
);


var emailChangeValidationMixin = {
    new_requested_email: {
        required: true,
        pattern: 'email',
        msg: "Email is required"
    }
  };

var CustomerEmailChangeModel = EntitiesBase.ModelBase.extend({
    defaults: {
      new_requested_email: null
    },
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    validation: {}
});
_.extend(CustomerEmailChangeModel.prototype, Backbone.Validation.mixin);
_.extend(
    CustomerEmailChangeModel.prototype.validation,
    emailChangeValidationMixin
);

var passwordChangeValidationMixin = {
    current_password: {
        required: true,
        msg: "Password is required"
    },
    new_requested_password: {
        fn: function(value, attr, computedState) {
          if (value == null || value == '') {
            return 'New password is required.';
          } else if (value.length < 6) {
            return 'Password must be at least 6 characters long.';
          }
        }
    },
    new_requested_password_match: {
      fn: function(value, attr, computedState) {
        var message = 'Passwords must match';
        if (value == null || value == '') {
          return message;
        } else if (computedState.new_requested_password !== value) {
          return message;
        }
      }
    }
  };

var CustomerPasswordChangeModel = EntitiesBase.ModelBase.extend({
    defaults: {
      current_password: null,
      new_requested_password: null,
      new_requested_password_match: null
    },
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    validation: {}
});
_.extend(CustomerPasswordChangeModel.prototype, Backbone.Validation.mixin);
_.extend(
    CustomerPasswordChangeModel.prototype.validation,
    passwordChangeValidationMixin
);


var nameChangeValidationMixin = {
  first_name: {
      required: true,
      pattern: '[a-zA-Z_]',
      rangeLength: [1, 25],
      msg: "First name is required"
  },
  last_name: {
      required: true,
      pattern: '[a-zA-Z_]',
      rangeLength: [1, 25],
      msg: "Last name is required"
  },
};

var CustomerNameChangeModel = EntitiesBase.ModelBase.extend({
    defaults: {
      first_name: null,
      last_name: null
    },
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    validation: {}
});
_.extend(CustomerNameChangeModel.prototype, Backbone.Validation.mixin);
_.extend(
    CustomerNameChangeModel.prototype.validation,
    nameChangeValidationMixin
);

module.exports = {
    CustomerModel: function  (data) {
      data.orders = new OrdersCollection(data.orders);
      data.favourite_products = new FavouriteProductsCollection(data.favourite_products);
      return new CustomerModel(data);
    },
    CustomerJoinClubModel: function (data) {
      return new CustomerJoinClubModel(data);
    },
    CustomerEmailChangeModel: function (data) {
      return new CustomerEmailChangeModel(data)
    },
    CustomerPasswordChangeModel: function (data) {
      return new CustomerPasswordChangeModel(data)
    },
    CustomerNameChangeModel: function (data) {
      return new CustomerNameChangeModel(data)
    },
    OrderModel: OrderModel
};



/** WEBPACK FOOTER **
 ** ./assets/js/entities/customer.js
 **/